import { useState, useEffect } from "react";
import axios from "axios";
import "./Logs.css";
import Header from "../../components/header";
import Footer from "../../components/Footer";
import { Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import MaskedTextInput from "react-text-mask";
import "react-datepicker/dist/react-datepicker.css";
import Spinner from 'react-bootstrap/Spinner';
import toast from "react-hot-toast";
import Loader from "../../components/Loader";

const Logs = () => {
    const [ID, setID] = useState("");
    const num = ID.trim()
    // console.log("id", typeof num)
    const [sequence, setSequence] = useState("");
    const [username, setUsername] = useState("");
    const [po, setPo] = useState("");
    const [startingDate, setStartingDate] = useState("")
    const [endingDate, SetEndingDate] = useState("")
    const [deleteStartingDate, setDeleteStartingDate] = useState("")
    const [deleteEndingDate, setDeleteEndingDate] = useState("")
    const [dropDownValue, setDropDownValue] = useState("");
    // console.log("dropDownValue",dropDownValue)
    const [filteredData, setFilteredData] = useState([]);
    // console.log("filterdata",filteredData)
    const [size0Index, setSize0Index] = useState([]);
    // console.log("4444",size0Index)
    const [logsApiData, setLogsApidata] = useState([]);
    // console.log("logsApiData",logsApiData)
    const [isApiLoading, setisApiLoading] = useState(false)
    const [showModalDeleteLogs, setShowModalDeleteLogs] = useState(false);
    const [isLoadingDeleteLogs, setIsLoadingDeleteLogs] = useState(false);
    const [showModalAutoDeleteLogs, setShowModalAutoDeleteLogs] = useState(false);
    const [isLoadingAutoDeleteLogs, setIsLoadingAutoDeleteLogs] = useState(false);
    const [autoDeleteLogsValue, setAutoDeleteLogsValue] = useState("")
    const [show, setShow] = useState(false);

    //logs api caal function
    const getFilter = async (e) => {
        e.preventDefault();

        // console.log("Sequence ID: ", sequence);
        // console.log("Username: ", username);
        // console.log("PO: ", po);
        // console.log("startDate",startingDate)
        // console.log("endDate",endingDate)
        // console.log("dropDownValue",dropDownValue)
        const api = `${process.env.REACT_APP_API_LINK}/api/v1/admin/getLogsPdfData?num=${dropDownValue}&PO=${po}&startDate=${startingDate}&seqID=${sequence}&endDate=${endingDate}`;
        const authToken = localStorage.getItem("token");
        try {
            setisApiLoading(true)
            const res = await axios.get(api, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            // console.log("res", res.data)
            // console.log('body data :::', res.data.map((bodyData)=> { return bodyData.bodyData}))
            setLogsApidata(res.data);
            // setSize0Index(res.data.bodyData)
            // setisApiLoading(false)
        }
        catch (error) {
            console.log("api not working", error)
        }
    };

    // useEffect(()=> {
    //     // e.preventDefault();
    //     getFilter()
    // }, [])
    // console.log("body", bodyData)


    // delete logs api call function
    const getDeletePdfDownloded = async () => {
        // Get the current date
        const currentDate = new Date();
        // Calculate the date 6 months ago from today
        const calculateDate = currentDate.setMonth(currentDate.getMonth() - 6);
        const finalCurrentDate = new Date(calculateDate);

        // console.log("finalDate>>>>", finalCurrentDate);
        const finalEndingDate = new Date(deleteEndingDate);

        const finalStartingDate = new Date(deleteStartingDate);

        if (finalCurrentDate >= finalEndingDate) {
            if (finalEndingDate >= finalStartingDate) {
                try {
                    setIsLoadingDeleteLogs(true);
                    const authToken = localStorage.getItem("token");
                    const { data } = await axios.get(
                        `${process.env.REACT_APP_API_LINK}/api/v1/admin/deleteLogs?startDate=${finalStartingDate}&endDate=${finalEndingDate}`,
                        {
                            headers: {
                                Authorization: `Bearer ${authToken}`,
                            },
                        }
                    );
                    // console.log("res",data.message)

                    if (data.message) {
                        toast.success(data.message);
                    }
                    setIsLoadingDeleteLogs(false);
                } catch (err) {
                    console.error(err);
                }
            } else {
                toast.error("Error: The ending date cannot be before the starting date.");
            }
        } else {
            toast.error("Selected date range is more than 6 months.");
        }





    };

    //all input reset value function
    const getResetValue = () => {
        setID("");
        setSequence("");
        setUsername("");
        setPo("");
        setStartingDate("");
        SetEndingDate("");
        setDropDownValue("");
        setFilteredData([]);
        setLogsApidata([]);
    };


    const getStartingDate = (date) => {
        setStartingDate(date)
    }

    const handleStartingDateChange = (date) => {
        setDeleteStartingDate(date);
        // console.log("400",date)
    };

    const getEndingDate = (date) => {
        SetEndingDate(date)
    }

    // dropDown function
    const handleDropDownChange = (e) => {
        setDropDownValue(e.target.value);
    };

    const handleShowModalDeleteLogs = (e) => {
        e.preventDefault();
        setShowModalDeleteLogs(true);
    };

    const handleShowModalAutoDeleteLogs = async (e) => {
        e.preventDefault();
        setShowModalAutoDeleteLogs(true);
        try {
            const authToken = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_API_LINK}/api/v1/admin/getLogsAutoDeleteDays`,
                {
                    // params: { days: autoDeleteLogsValue },
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            // console.log("API Response:", response.data.days);
            // toast.success(response.data.message)
            setAutoDeleteLogsValue(response.data.days);

        } catch (error) {
            console.error(" Auto Delete fetch  API Error calling API:", error);
            toast.dismiss()
            toast.error(error.message)
        }
        finally {
            setIsLoadingAutoDeleteLogs(false)
        }
    };

    //modal function
    const handleCloseModalDeleteLogs = () => {
        setShowModalDeleteLogs(false);
        setDeleteEndingDate("");
        setDeleteStartingDate("");
    };

    const handleCloseModalAutoDeleteLogs = () => {
        setShowModalAutoDeleteLogs(false);
        setAutoDeleteLogsValue("")
    };

    const handleEndingDateChange = (date) => {
        setDeleteEndingDate(date);
        // console.log("500",date)
    };

    //table filter function
    useEffect(() => {
        const filtered = logsApiData?.filter((item) => {
            setisApiLoading(false)
            // console.log("1414", typeof item.id);
            let bodyData = {};
            try {
                bodyData = item.bodyData ? JSON.parse(item.bodyData) : {};
            } catch (error) {
                console.error("Error parsing bodyData:", error);
            }

            return (
                (num ? (typeof item.id === "number" && String(item.id).includes(num)) : true) &&
                (sequence ? (typeof item.seqID === "string" && item.seqID.toLowerCase().includes(sequence.toLowerCase())) ||
                    (typeof bodyData.seqId === "string" && bodyData.seqId.toLowerCase().includes(sequence.toLowerCase())) ||
                    (typeof bodyData.boxData?.[0]?.id === "string" && bodyData.boxData?.[0]?.id.toLowerCase().includes(sequence.toLowerCase())) ||
                    (typeof bodyData.entryId === "string" && bodyData.entryId.toLowerCase().includes(sequence.toLowerCase()))
                    : true) &&
                (username ? item.username.toLowerCase().includes(username.toLowerCase()) : true) &&
                (po ? (
                    (typeof item.PO === "string" && item.PO?.toLowerCase()?.includes(po.toLowerCase())) ||
                    (typeof bodyData.weightData?.PO === "string" && bodyData.weightData?.PO?.toLowerCase()?.includes(po.toLowerCase()))
                ) : true)
            );
        });

        setFilteredData(filtered);
    }, [num, sequence, username, po, startingDate, endingDate, logsApiData]);


    // size mapping 
    // UseEffect to set initial state based on filteredData
    useEffect(() => {
        if (filteredData && filteredData.length > 0) {
            const userEntriesSize0Index = filteredData.map((item) => {
                try {
                    const parsedData = JSON.parse(item.bodyData);
                    if (Array.isArray(parsedData?.userEntries)) {
                        const data = parsedData.userEntries.map((entry) => entry[0]); // First element of each entry
                        // return data;
                        // console.log("12",data)
                    }
                    // return parsedData; // Default empty array if userEntries is not valid
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    return error; // Return an empty array to avoid errors
                }
            }).flat(); // Flatten to avoid nested arrays

            setSize0Index(userEntriesSize0Index);
        }
    }, [filteredData]);






    //tr onClick function
    const getShowData = () => {
        setShow(true)
    }

    // tr close modal function
    const handleClose = () => {
        setShow(false);
    }

    const getAutoDeleteLogs = (e) => {
        const { value } = e.target;

        const regex = /^[0-9]{0,3}$/;

        if (regex.test(value)) {
            setAutoDeleteLogsValue(value);
        }
    };

    const getAutoDeleteLogsSubmit = async () => {
        setIsLoadingAutoDeleteLogs(true)
        try {
            const authToken = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_API_LINK}/api/v1/admin/setLogsAutoDeleteDays`,
                {
                    params: { days: autoDeleteLogsValue },
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            // console.log("API Response:", response.data);
            toast.success(response.data.message)

            // Reset input
            // setAutoDeleteLogsValue("");

        } catch (error) {
            console.error(" Auto Delete API Error calling API:", error);
            toast.dismiss()
            toast.error(error.message)
        }
        finally {
            setIsLoadingAutoDeleteLogs(false)
        }
    };


    return (
        <>
            <Header />
            <div className="logs_container">
                <Container fluid id="container_logs">
                    <Row
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "centers",
                        }}
                    >
                        <Col lg={2} id="column">
                            <div className="form-group" id="sequence_id">
                                <Form.Label className="fs-6" id="input_lable">ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="sequence"
                                    value={ID}
                                    style={{ width: "100px" }}
                                    placeholder="ID"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {  // Allow only numbers (no letters or special characters)
                                            setID(value);
                                        }
                                    }}
                                    disabled={isApiLoading ? "disable" : null}

                                />
                            </div>
                        </Col>
                        <Col lg={2} id="column">
                            <div className="form-group" id="sequence_id">
                                <Form.Label className="fs-6" id="input_lable">Sequence ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="sequence"
                                    value={sequence}
                                    style={{ width: "100px" }}
                                    placeholder="Sequence ID"
                                    autoComplete="off"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {  // Allow only numbers (no letters or special characters)
                                            setSequence(value);
                                        }
                                    }}
                                    disabled={isApiLoading ? "disable" : null}
                                />
                            </div>
                        </Col>
                        <Col lg={2} id="column">
                            <div className="form-group" id="sequence_id">
                                <Form.Label className="fs-6" id="input_lable">Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="username"
                                    value={username}
                                    style={{ width: "100px" }}
                                    placeholder="Username"
                                    autoComplete="off"
                                    onChange={(e) => setUsername(e.target.value)}
                                    disabled={isApiLoading ? "disable" : null}
                                />
                            </div>
                        </Col>
                        <Col lg={2} id="column">
                            <div className="form-group" id="sequence_id">
                                <Form.Label className="fs-6" id="input_lable">PO#</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="po"
                                    value={po}
                                    style={{ width: "100px" }}
                                    placeholder="PO"
                                    autoComplete="off"
                                    // onChange={(e) => setPo(e.target.value)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {  // Allow only numbers (no letters or special characters)
                                            setPo(value);
                                        }
                                    }}
                                    disabled={isApiLoading ? "disable" : null}
                                />
                            </div>
                        </Col>
                        <Col lg={2} id="column">
                            <div className="form-group" id="date_input_main">
                                <Form.Label className="fs-6" id="input_lable">Starting Date</Form.Label>
                                <DatePicker
                                    id="date_input"
                                    className="form-control border border-dark my-1 "
                                    selected={startingDate}  // ✅ 
                                    onChange={getStartingDate} // ✅
                                    title="Enter date to Filter the table"
                                    name="startingDate"
                                    dateFormat="dd/MM/yyyy" // ✅ Ensures the correct format in the DatePicker
                                    disabled={isApiLoading ? "disable" : null}
                                    placeholderText="Start Date"
                                    showMonthDropdown
                                    showYearDropdown
                                    showPopperArrow
                                    customInput={
                                        <MaskedTextInput
                                            type="text"
                                            mask={[
                                                /\d/,
                                                /\d/,
                                                "/",
                                                /\d/,
                                                /\d/,
                                                "/",
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                            ]}
                                        />
                                    }
                                    autoComplete="off"
                                />
                            </div>
                        </Col>
                        <Col lg={2} id="column">
                            <div className="form-group" id="date_input_main">
                                <Form.Label className="fs-6" id="input_lable">Ending Date</Form.Label>
                                <DatePicker
                                    id="date_input"
                                    className="form-control border border-dark my-1 "
                                    selected={endingDate}
                                    onChange={getEndingDate}
                                    title="Enter date to Filter the table"
                                    name="startingDate"
                                    dateFormat="dd/MM/yyyy" // ✅ Ensures the correct format in the DatePicker
                                    disabled={isApiLoading ? "disable" : null}
                                    placeholderText="End Date"
                                    showMonthDropdown
                                    showYearDropdown
                                    showPopperArrow
                                    customInput={
                                        <MaskedTextInput
                                            type="text"
                                            mask={[
                                                /\d/,
                                                /\d/,
                                                "/",
                                                /\d/,
                                                /\d/,
                                                "/",
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                            ]}
                                        />
                                    }
                                    autoComplete="off"
                                />
                            </div>
                        </Col>
                        <Col lg={2} id="column">
                            <div className="form-group" id="sequence_id">
                                <Form.Label className="fs-6" id="input_lable">Select Range</Form.Label>
                                <Form.Select id="date_input" value={dropDownValue} onChange={handleDropDownChange}
                                    disabled={isApiLoading ? "disable" : null}
                                >
                                    <option value="">Default select</option>
                                    <option value="1">1-1</option>
                                    <option value="5">1-5</option>
                                    <option value="10">1-10</option>
                                    <option value="20">1-20</option>
                                    <option value="50">1-50</option>
                                    <option value="100">1-100</option>
                                    <option value="200">1-200</option>
                                    <option value="300">1-300</option>
                                    <option value="400">1-400</option>
                                    <option value="500">1-500</option>
                                    {/* <option value="10000000">500+</option> */}
                                </Form.Select>
                            </div>
                        </Col>
                        <Col lg={4} style={{ padding: "0" }}>
                            <div id="btn_both_logs">
                                <Button variant="primary" className="me-2"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        getFilter(e)
                                    }}
                                    disabled={!dropDownValue || dropDownValue === ""}
                                >
                                    {isApiLoading ? <Spinner id="spinnerr" animation="border" variant="light" /> : "Filter"}
                                </Button>
                                <Button
                                    variant="danger"
                                    className="me-2"
                                    onClick={getResetValue}
                                    disabled={isApiLoading ? "disable" : null}
                                >
                                    Reset
                                </Button>
                                <Button variant="success" style={{ width: "fit-content" }}
                                    onClick={(e) => handleShowModalDeleteLogs(e)}
                                    disabled={isApiLoading ? "disable" : null}
                                >
                                    Delete Logs
                                </Button>
                                <Modal
                                    id="modal_main"
                                    show={showModalDeleteLogs}
                                    onHide={handleCloseModalDeleteLogs}
                                    className="modal-dialog-centered"
                                >
                                    <Modal.Header
                                        closeButton
                                        style={{ width: "500px", padding: "4%" }}
                                    >
                                        <Modal.Title> Delete Logs Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body id="modal_body">
                                        <div className="logs_modal_body_main">
                                            <div id="logs_modal_body_data1_main" class="form-group">
                                                <label for="pwd">Starting Date:</label>
                                                <DatePicker
                                                    id="DatePicker"
                                                    className="form-control"
                                                    wrapperClassName="datePicker"
                                                    name="etd"
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Select a date"
                                                    selected={deleteStartingDate} // Bind selectedDate state
                                                    onChange={handleStartingDateChange}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    customInput={
                                                        <MaskedTextInput
                                                            id="date_input"
                                                            type="text"
                                                            mask={[
                                                                /\d/,
                                                                /\d/,
                                                                "/",
                                                                /\d/,
                                                                /\d/,
                                                                "/",
                                                                /\d/,
                                                                /\d/,
                                                                /\d/,
                                                                /\d/,
                                                            ]}
                                                        />
                                                    }
                                                    autoComplete="off"
                                                />
                                            </div>
                                            {/*  */}
                                            <div id="logs_modal_body_data1_main" class="form-group">
                                                <label for="pwd">Ending Date:</label>
                                                <DatePicker
                                                    id="DatePicker"
                                                    className="form-control"
                                                    wrapperClassName="datePicker"
                                                    name="etd"
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Select a date"
                                                    selected={deleteEndingDate} // Bind selected date state
                                                    onChange={handleEndingDateChange}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    // minDate={subMonths(new Date(), 6)} // Disable all dates before 6 months from today
                                                    // maxDate={new Date()} // Disable all dates after the current date
                                                    // excludeDateIntervals={[
                                                    //   {
                                                    //     start: subMonths(new Date(), 6),
                                                    //     end: new Date(),
                                                    //   },
                                                    // ]}
                                                    customInput={
                                                        <MaskedTextInput
                                                            id="date_input"
                                                            type="text"
                                                            mask={[
                                                                /\d/,
                                                                /\d/,
                                                                "/",
                                                                /\d/,
                                                                /\d/,
                                                                "/",
                                                                /\d/,
                                                                /\d/,
                                                                /\d/,
                                                                /\d/,
                                                            ]}

                                                        />
                                                    }
                                                    autoComplete="off"
                                                />
                                            </div>

                                            {/*  */}
                                            <div id="log_body_btn_main">
                                                <button
                                                    type="button"
                                                    class="btn btn-success"
                                                    style={{ width: "fit-content" }}
                                                    onClick={getDeletePdfDownloded}
                                                // disabled={
                                                //   dropDownValue.length === 0 ||
                                                //   dropDownValue.length >= 10
                                                // }
                                                >
                                                    {isLoadingDeleteLogs ? "Loading...." : " Delete Logs"}
                                                </button>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                                <Button variant="success" style={{ width: "fit-content" }}
                                    onClick={(e) => handleShowModalAutoDeleteLogs(e)}
                                    disabled={isApiLoading ? "disable" : null}
                                >
                                    Auto Delete Logs
                                </Button>
                                <Modal
                                    id="modal_main"
                                    show={showModalAutoDeleteLogs}
                                    onHide={handleCloseModalAutoDeleteLogs}
                                    className="modal-dialog-centered"
                                >
                                    <Modal.Header
                                        closeButton
                                        style={{ width: "500px", padding: "4%" }}
                                    >
                                        <Modal.Title>Auto Delete Logs Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body id="modal_body">
                                        <div className="logs_modal_body_main">
                                            <div id="logs_modal_body_data1_main" className="form-group"
                                                style={{ display: "flex" }}>
                                                <label className="lable_text">Keep Logs Days&nbsp;:-</label>

                                                <div className="autoDlete-input">
                                                    <input
                                                        type="text"
                                                        name="autoDeletelogs"
                                                        value={autoDeleteLogsValue}
                                                        onChange={getAutoDeleteLogs}
                                                        placeholder="Enter Days"
                                                        autoComplete="off"
                                                    />
                                                </div>


                                            </div>
                                            <div className="alert-text">Enter only numeric value (max 3 digits)</div>


                                            {/*  */}
                                            <div id="log_body_btn_main">
                                                <button
                                                    type="button"
                                                    class="btn btn-success"
                                                    style={{ width: "fit-content" }}
                                                    onClick={getAutoDeleteLogsSubmit}
                                                    disabled={isLoadingAutoDeleteLogs}
                                                // disabled={
                                                //   dropDownValue.length === 0 ||
                                                //   dropDownValue.length >= 10
                                                // }
                                                >
                                                    {isLoadingAutoDeleteLogs ?
                                                        <div class="spinner-border spinner-border-sm" role="status">
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                        : " Save"}
                                                </button>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </Col>
                    </Row>
                </Container>


                {/* Table */}
                <div className="table-responsive  tableFixHead table-container" id="table">
                    <div id="table_1">
                        <table className="table table-bordered table-hover table-sm table-header-for-all" >
                            <thead>
                                <tr className="table-warning">
                                    <th><div id="table_th">S.No.</div></th>
                                    <th><div id="table_th">ID</div></th>
                                    <th><div id="table_th">SequenceID</div></th>
                                    <th><div id="table_th">Username</div></th>
                                    <th><div id="table_th_1">Style</div></th>
                                    <th><div id="table_th_1">PO#</div></th>
                                    <th><div id="table_th">Factory</div></th>
                                    <th><div id="table_th">Supplier</div></th>
                                    <th><div id="table_th">Agent</div></th>
                                    <th><div id="table_th_1">Action Name</div></th>
                                    <th><div id="table_th">Type</div></th>
                                    <th><div id="table_th">PO Entries</div></th>
                                    <th><div id="table_th_1">User Entries</div></th>
                                    <th><div id="table_th">User to User</div></th>
                                    <th><div id="table_th">Total_Qty</div></th>
                                    {/* <th><div id="table_th">Version</div></th> */}
                                    <th><div id="table_th_1">Box Type</div></th>
                                    <th><div id="table_th">From</div></th>
                                    <th><div id="table_th">To</div></th>
                                    <th><div id="table_th">Length</div></th>
                                    <th><div id="table_th">Width</div></th>
                                    <th><div id="table_th">Height</div></th>
                                    <th><div id="table_th">GrossWt</div></th>
                                    <th><div id="table_th">NetWt</div></th>


                                    <th><div id="table_th">Sent</div></th>
                                    <th><div id="table_th_1">Box Group</div></th>
                                    <th><div id="table_th">No of Boxes</div></th>

                                    <th><div id="table_th">CLR</div></th>
                                    <th><div id="table_th">DES</div></th>
                                    <th><div id="table_th">DIM</div></th>
                                    <th><div id="table_th">FCUS</div></th>
                                    <th><div id="table_th">LOT</div></th>
                                    <th><div id="table_th">SEA</div></th>
                                    <th><div id="table_th">SIZE</div></th>
                                    <th><div id="table_th">SOL</div></th>

                                    <th><div id="table_th">TYP</div></th>
                                    <th><div id="table_th_1">Purchase_Order(TOT_QTY)</div></th>
                                    <th><div id="table_th_1">Balance_Quantity(TOT_QTY)</div></th>
                                    <th><div id="table_th">Locked</div></th>
                                    <th><div id="table_th_1">Created_At</div></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    isApiLoading ? (
                                        <tr>
                                            <td colSpan={15} className="text-center">
                                                <Loader style={{ height: "20vh" }} />
                                            </td>
                                        </tr>
                                    ) :
                                        filteredData && filteredData.length > 0 ? (
                                            filteredData.map((item, index) => (
                                                // setSize0Index(JSON.parse(item.bodyData)),
                                                // console.log("item123",JSON.parse(item.bodyData).userEntries),
                                                // console.log("item1234",JSON.parse(item.bodyData).userEntries?.[1]),
                                                <tr key={index}>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{index + 1}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{item.id}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        {(() => {
                                                            try {
                                                                if (item.seqID) {
                                                                    return item.seqID;
                                                                } else if (item.bodyData) {
                                                                    return JSON.parse(item.bodyData).seqId;
                                                                } else if (item.weightData) {
                                                                    return JSON.parse(item.weightData).id;
                                                                }
                                                                else if (item.bodyData) {
                                                                    return JSON.parse((item.bodyData)).entryId;
                                                                }
                                                                return "N/A"; // If all conditions fail
                                                            } catch (error) {
                                                                console.error("Error parsing JSON:", error);
                                                                return "N/A"; // In case of JSON parse error
                                                            }
                                                        })()}
                                                    </td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{item.username}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.STY}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{item.PO ? item.PO : JSON.parse(item.bodyData).weightData?.PO}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.FACT}</td>
                                                    {/* SUP MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let sup = {};
                                                                try {
                                                                    sup = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("sup",sup.SUP)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {sup.SUP}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>

                                                    {/* angt MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let agnt = {};
                                                                try {
                                                                    agnt = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("agnt",agnt.AGNT)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {agnt.AGNT}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>

                                                    <td style={{ fontWeight: "500" }} id="table_td">{item.actionName}
                                                    </td>
                                                    {/* Type Data Mapping */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div id="type">{JSON.parse((item.bodyData)).type}</div>
                                                    </td>

                                                    {/* PO Entries Mapping */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div id="po_entries_main">
                                                            <div id="po_entries_0">
                                                                <div id="type">{JSON.parse((item.bodyData)).poEntries?.[0]}</div>
                                                            </div>
                                                            <div id="po_entries_1">
                                                                <div id="type">{JSON.parse((item.bodyData)).poEntries?.[1]}</div>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Entry ID Mapping */}
                                                    {/* <td style={{ fontWeight: "500" }}>
                                                <div id="type">{JSON.parse((item.bodyData)).entryId}</div>
                                            </td> */}

                                                    {/* user Entries */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div id="user_Entries_main">
                                                            <div id="index_0">
                                                                <div id="index_0_data_main">
                                                                    <div id="index_0_data">SZ01</div>
                                                                    <div id="index_0_data">SZ02</div>
                                                                    <div id="index_0_data">SZ03</div>
                                                                    <div id="index_0_data">SZ04</div>
                                                                    <div id="index_0_data">SZ05</div>
                                                                    <div id="index_0_data">SZ06</div>
                                                                    <div id="index_0_data">SZ07</div>
                                                                    <div id="index_0_data">SZ08</div>
                                                                    <div id="index_0_data">SZ09</div>
                                                                    <div id="index_0_data">SZ010</div>
                                                                    <div id="index_0_data">SZ011</div>
                                                                    <div id="index_0_data">SZ012</div>
                                                                </div>
                                                                <div id="index_0_data_value_main">
                                                                    {(() => {
                                                                        // Object.keys(object1)
                                                                        const objecCheck = typeof (JSON.parse(item.bodyData).userEntries)
                                                                        const justKeys = objecCheck === 'object' ? Object.keys(JSON.parse(item.bodyData)?.userEntries) : []
                                                                        const boxData = JSON.parse(item.bodyData).userEntries?.[justKeys?.[0]] || {};
                                                                        return (
                                                                            <>
                                                                                <>
                                                                                    <div id={boxData.SZ01 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ01 || 1}</div>
                                                                                    <div id={boxData.SZ02 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ02 || 1}</div>
                                                                                    <div id={boxData.SZ03 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ03 || 1}</div>
                                                                                    <div id={boxData.SZ04 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ04 || 1}</div>
                                                                                    <div id={boxData.SZ05 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ05 || 1}</div>
                                                                                    <div id={boxData.SZ06 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ06 || 1}</div>
                                                                                    <div id={boxData.SZ07 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ07 || 1}</div>
                                                                                    <div id={boxData.SZ08 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ08 || 1}</div>
                                                                                    <div id={boxData.SZ09 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ09 || 1}</div>
                                                                                    <div id={boxData.SZ10 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ10 || 1}</div>
                                                                                    <div id={boxData.SZ11 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ11 || 1}</div>
                                                                                    <div id={boxData.SZ12 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ12 || 1}</div>
                                                                                </>

                                                                            </>
                                                                        );
                                                                    })()}
                                                                </div>

                                                            </div>
                                                            {/* index 1 */}
                                                            <div id="index_1">
                                                                <div id="index_0_data_main">
                                                                    <div id="index_0_data_2">SZ01</div>
                                                                    <div id="index_0_data_2">SZ02</div>
                                                                    <div id="index_0_data_2">SZ03</div>
                                                                    <div id="index_0_data_2">SZ04</div>
                                                                    <div id="index_0_data_2">SZ05</div>
                                                                    <div id="index_0_data_2">SZ06</div>
                                                                    <div id="index_0_data_2">SZ07</div>
                                                                    <div id="index_0_data_2">SZ08</div>
                                                                    <div id="index_0_data_2">SZ09</div>
                                                                    <div id="index_0_data_2">SZ010</div>
                                                                    <div id="index_0_data_2">SZ011</div>
                                                                    <div id="index_0_data_2">SZ012</div>
                                                                </div>
                                                                <div id="index_0_data_value_main">
                                                                    {(() => {
                                                                        const objecCheck = typeof (JSON.parse(item.bodyData)?.userEntries)
                                                                        const justKeys = objecCheck === 'object' ? Object.keys(JSON.parse(item.bodyData)?.userEntries) : []
                                                                        // console.log('just keys', justKeys)
                                                                        // console.log('userEntries check', JSON.parse(item.bodyData).userEntries)
                                                                        const boxData = JSON.parse(item.bodyData).userEntries?.[justKeys?.[1]] || {};
                                                                        // console.log("12345",boxData)
                                                                        return (
                                                                            <>
                                                                                <>
                                                                                    <div id={boxData.SZ01 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ01 || 1}</div>
                                                                                    <div id={boxData.SZ02 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ02 || 1}</div>
                                                                                    <div id={boxData.SZ03 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ03 || 1}</div>
                                                                                    <div id={boxData.SZ04 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ04 || 1}</div>
                                                                                    <div id={boxData.SZ05 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ05 || 1}</div>
                                                                                    <div id={boxData.SZ06 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ06 || 1}</div>
                                                                                    <div id={boxData.SZ07 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ07 || 1}</div>
                                                                                    <div id={boxData.SZ08 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ08 || 1}</div>
                                                                                    <div id={boxData.SZ09 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ09 || 1}</div>
                                                                                    <div id={boxData.SZ10 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ10 || 1}</div>
                                                                                    <div id={boxData.SZ11 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ11 || 1}</div>
                                                                                    <div id={boxData.SZ12 ? "index_0_data_" : "index_0_data_1"}>{boxData.SZ12 || 1}</div>
                                                                                </>

                                                                            </>
                                                                        );
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {/* user to usre MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let user = {};

                                                                try {
                                                                    user = JSON.parse(item.QueryData) || {};
                                                                    // console.log("user",user)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {user.user_to_use}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* total qty mapping */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let boxData = {};
                                                                let boxData1 = {};
                                                                try {
                                                                    boxData = JSON.parse(item.bodyData)?.boxData?.[0] || {};
                                                                    // console.log("boxData",boxData)
                                                                    boxData1 = JSON.parse(item.bodyData).weightData || {};
                                                                    // console.log("boxData1",boxData1.TOT_QTY)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {(item.actionName === "specific modify") ? ("") : (boxData.TOT_QTY ? boxData.TOT_QTY : boxData1.TOT_QTY)}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* BoxType MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        {/* {JSON.parse(item.bodyData).weightData?.BoxType} */}
                                                        <div>
                                                            {(() => {
                                                                let BOXTYPE = {};
                                                                // let BOXTYPE1 ={};
                                                                let BOXTYPE2 = {};
                                                                try {
                                                                    BOXTYPE = JSON.parse(item.bodyData).weightData || {};
                                                                    // console.log("boxType",BOXTYPE)
                                                                    // BOXTYPE1 = JSON.parse(item.QueryData) || {};
                                                                    // console.log("boxType1",BOXTYPE1)
                                                                    BOXTYPE2 = JSON.parse(item.bodyData) || {};
                                                                    // console.log("boxType2",BOXTYPE2)

                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {BOXTYPE.BoxType}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>

                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.From}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.To}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.Length}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.Width}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.Height}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.GrossWt}</td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.NetWt}</td>


                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.sent ? "True" : "False"}</td>

                                                    {/* BoxGroup MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        {/* {JSON.parse(item.bodyData).weightData?.BoxGroup} */}
                                                        <div>
                                                            {(() => {
                                                                let BOXGROUP = {};
                                                                let BOXGROUP1 = {};
                                                                let BOXGROUP2 = {};
                                                                try {
                                                                    BOXGROUP = JSON.parse(item.bodyData).boxData || {};
                                                                    // console.log("boxData",BOXGROUP, 'body', JSON.parse(item.bodyData))
                                                                    BOXGROUP1 = JSON.parse(item.QueryData) || {};
                                                                    // console.log("query_Group",BOXGROUP1)
                                                                    BOXGROUP2 = JSON.parse(item.bodyData).weightData || {};
                                                                    // console.log("weight_Data",BOXGROUP1)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {BOXGROUP.BoxGroup || BOXGROUP1.BoxGroup || BOXGROUP2.BoxGroup}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td style={{ fontWeight: "500" }} id="table_td">{JSON.parse(item.bodyData).weightData?.noOfBoxes ? JSON.parse(item.bodyData).weightData?.noOfBoxes : JSON.parse(item.bodyData).weightData?.numOfBoxes}</td>

                                                    {/* CLR MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let clr = {};
                                                                try {
                                                                    clr = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("clr",clr.CLR)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {clr.CLR}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* DES MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let des = {};
                                                                try {
                                                                    des = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("clr",des.DES)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {des.DES}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* DIM MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let dim = {};
                                                                try {
                                                                    dim = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("clr",des.DIM)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {dim.DIM}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* FCUS MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let fcus = {};
                                                                try {
                                                                    fcus = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("fcus",fcus.FCUS)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {fcus.FCUS}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* LOT MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let lot = {};
                                                                try {
                                                                    lot = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("lot",lot.LOT)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {lot.LOT}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* SEA MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let sea = {};
                                                                try {
                                                                    sea = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("sea",sea.SEA)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {sea.SEA}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* Size MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let size = {};
                                                                try {
                                                                    size = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("size",size.SIZE)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {size.SIZE}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* SOL MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let sol = {};
                                                                try {
                                                                    sol = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("sol",sol.SOL)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {sol.SOL}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>

                                                    {/* TYP MAPPING */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let typ = {};
                                                                try {
                                                                    typ = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("typ",typ.TPY)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {typ.TYP}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* purchaseOrder Total_qty */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let tot_qty = {};
                                                                try {
                                                                    tot_qty = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("tot_qty",tot_qty.TOT_QTY)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {tot_qty.TOT_QTY}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* BalanceQuanityt  Total_qty */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let tot_qty = {};
                                                                try {
                                                                    tot_qty = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder?.balanceQuantity || {};
                                                                    // console.log("tot_qty",tot_qty.TOT_QTY)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {tot_qty.TOT_QTY}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    {/* Locked mapping */}
                                                    <td style={{ fontWeight: "500" }} id="table_td">
                                                        <div>
                                                            {(() => {
                                                                let Locked = {};
                                                                try {
                                                                    Locked = JSON.parse(item.bodyData).boxData?.[0]?.purchaseOrder || {};
                                                                    // console.log("Locked",Locked.locked)
                                                                } catch (error) {
                                                                    console.error("Error parsing bodyData:", error);
                                                                }

                                                                return (
                                                                    <div>
                                                                        {Locked.locked ? "True" : "False"}
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td style={{ fontWeight: "500" }} id="table_td"> {new Date(item.createdAt).toLocaleDateString("en-GB").split("/").join("-")}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={40} className="text-center">No Records Found</td>
                                            </tr>
                                        )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    );
};

export default Logs;
